<div class="account-deletion-container">
  <ng-container *ngIf="!showError">
    <div class="logo">
      <svg-icon src="/assets/icons/info-circle.svg" class="white-logo"></svg-icon>
    </div>
    <h1>Request Account Deletion</h1>
    <h2>{{ dataStoreService.user?.email }}</h2>
    <p class="description">Initiate a request to delete your Kumanu account.</p>
    <p class="description">
      Upon deletion, you will no longer be able to access your account or any information you've put into any Kumanu
      apps you've used.
    </p>
    <button class="button button-pill" [disabled]="processing" (click)="deleteAccount()">Continue</button>
  </ng-container>
  <ng-container *ngIf="showError">
    <div class="logo">
      <svg-icon src="/assets/icons/alert-circle.svg" class="white-logo"></svg-icon>
    </div>
    <h1>Something went wrong</h1>
    <p class="description">Your account deletion request was not processed. Please try again.</p>
    <!-- Adding comment to remove extra space that Prettier adds around the link and before the period -->
    <!-- prettier-ignore -->
    <p class="description">If the problem persists, contact us at<a href="mailto:support@kumanu.com">support@kumanu.com</a>.
    </p>
    <button class="button button-pill" [disabled]="processing" (click)="deleteAccount()">Try again</button>
  </ng-container>
</div>
